module.exports = __webpack_public_path__ + "3369392f342de871addb2e2d6d2bf872.fbx";